// import T from 'prop-types'

import * as S from '../components/Static.styles'

const defaultProps = {}
const propTypes = {}

export const TOS = () => {
  return (
    <S.Article id="post-59918">
      <S.Header>
        <S.Title>Trialsite Terms of Service</S.Title>
      </S.Header>
      <S.Content>
        <p>
          PLEASE READ THE TERMS OF USE CAREFULLY BEFORE ACCESSING THE “SITE” OR
          USING ANY PART OF THE SITE OR “SERVICE” (BOTH AS DEFINED BELOW). BY
          VISITING THE SITE AND/OR USING OR ACCESSING THE SERVICES, THE USER
          (“YOU”) AGREE TO BECOME BOUND BY THE TERMS OF USE AND THE TRIALSITE
          PRIVACY POLICY, INCORPORATED BY REFERENCE. THESE TERMS OF USE APPLY TO
          ALL USERS OF THE SERVICE, WHETHER VISITOR OR MEMBER, INCLUDING USERS
          WHO ARE ALSO CONTRIBUTORS OF CONTENT, INFORMATION, AND OTHER MATERIALS
          OR SERVICES ON THE SITE. IF YOU DO NOT UNCONDITIONALLY AGREE TO ALL
          THE TERMS AND CONDITIONS OF THE TERMS OF USE, YOU DO NOT HAVE ANY
          RIGHT TO USE THE SITE OR THE SERVICES. TRIALSITE’S ACCEPTANCE IS
          EXPRESSLY CONDITIONED UPON YOUR ASSENT TO ALL THE TERMS AND CONDITIONS
          OF THIS AGREEMENT; YOUR CONTINUED USE OF OR ACCESS TO THE SITE AND/OR
          SERVICES WILL BE DEEMED ACCEPTANCE OF THE TERMS OF USE.
        </p>
        <p>
          <strong>Acceptance of Terms</strong>
        </p>
        <p>
          The following terms and conditions govern all use of the
          trialSitenews.com website (the Site) and the services available on or
          at the Site (the Service). The Service is owned and operated by
          TrialSite, Inc. The Service is offered subject to acceptance without
          modification of all of the terms and conditions contained herein (the
          Terms of Use) and all other operating rules, policies and procedures
          that may be published from time to time on the Site by TrialSite.
        </p>
        <p>
          The Service is available only to individuals who are at least 16 years
          old or who are emancipated minors, or possess legal parental or
          guardian consent, and are fully able and competent to enter into the
          terms, conditions, obligations, affirmations, representations, and
          warranties set forth in these Terms of Use, and to abide by and comply
          with these Terms of Use. In any case the Site is not intended for
          children under the age of 13. If you are less than 13 years of age,
          please do not use the Site. TrialSite may, at its sole discretion,
          refuse to offer the Service to any person or entity and change its
          eligibility criteria at any time.
        </p>
        <p>
          TrialSite reserves the right, at its sole discretion, to modify or
          replace any of the Terms of Use at any time, by posting the modified
          Terms of Use or other policies or guidelines on the Site, and if
          permitted to do so, sending you an e-mail notifying you of the nature
          of the modifications and a link to the modified document on the Site
          so that you may review it. It is your responsibility to check the
          Terms of Use periodically for changes. Your continued use of the
          Service following the posting or notification of any changes to the
          Terms of Use constitutes your acceptance of those changes and your
          agreement to abide and be bound by the Terms of Use, as amended. If at
          any time you choose not to accept the Terms of Use, including
          following receipt of notification of any modifications hereto, then
          please do not use the Site.
        </p>
        <p>
          <strong>Rules and Conduct</strong>
        </p>
        <p>
          As a condition of use, you promise not to use the Service for any
          purpose that is prohibited by the Terms of Use. The Service
          (including, without limitation, any Content or User Submissions (both
          as defined below)) is provided only for your own personal use. For
          purposes of the Terms of Use, “Content” includes, without limitation,
          any video, audio, information, data, text, software, images,
          photographs, scripts, graphics, logos, interactive features, and other
          works of authorship in any form, medium or technology now known or
          later developed, which is generated, provided, or otherwise made
          accessible by TrialSite on or through the Service.
        </p>
        <p>
          By way of example, and not as a limitation, you must not (or permit
          others to) either (a) take any action or (b) upload, download, post,
          submit or otherwise distribute or facilitate distribution of any
          content using any communications service or other service available on
          or through the Service, that:
        </p>
        <p>
          infringes any patent, trademark, service mark, trade secret,
          copyright, right of privacy or publicity or other right of any other
          person or entity;
        </p>
        <p>
          includes video or a photograph of another person or an identifiable
          location that you have posted without that person’s or the owner of
          such location’s consent;
        </p>
        <p>
          is unlawful, threatening, abusive, harassing, defamatory, libelous,
          deceptive, fraudulent, invasive of another’s privacy, tortious,
          obscene, offensive, sexually explicit or profane, depicts nudity,
          unlawful activities, death or violence, or encourages conduct that
          could constitute a criminal offense;
        </p>
        <p>
          constitutes unauthorized or unsolicited advertising, junk or bulk
          e-mail (“spamming”);
        </p>
        <p>
          involves commercial activities and/or sales, such as contests,
          sweepstakes, barter, advertising, or pyramid schemes, without
          TrialSite’s prior written consent;
        </p>
        <p>
          advertises to, or solicits, any other user of the Service to buy or
          sell any products or services through the Service other than as
          incorporated in User Submissions which are otherwise in accordance
          with these Terms of Use ;
        </p>
        <p>
          displays an advertisement, or accepts payment or anything of value
          from a third person in exchange for your performing any activity on or
          through the Service on behalf of that person, such as posting
          commercial content, or posting blogs or bulletins with a commercial
          purpose;
        </p>
        <p>
          contains software viruses or any other computer codes, files, or
          programs that are designed or intended to disrupt, damage, limit or
          interfere with the proper function of any software, hardware, or
          telecommunications equipment or to damage or obtain unauthorized
          access to any system, data or other information of TrialSite or any
          third party; or
        </p>
        <p>
          impersonates any person or entity, including any employee or
          representative of TrialSite.
        </p>
        <p>
          Additionally, you must not: (i) take any action that imposes or may
          impose (as determined by TrialSite in its sole discretion) an
          unreasonable or disproportionately large strain on TrialSite’s
          infrastructure; (ii) interfere or attempt to interfere with the proper
          working of the Service or any activities conducted on the Service; or
          (iii) bypass any measures TrialSite may use to prevent or restrict
          access to the Service (or other accounts, computer systems or networks
          connected to the Service).
        </p>
        <p>
          You must not (directly or indirectly): (i) decipher, decompile,
          disassemble, reverse engineer or otherwise attempt to derive any
          source code or underlying ideas or algorithms of any part of the
          Service, except to the limited extent applicable laws specifically
          prohibit such restriction, (ii) modify, translate, or otherwise create
          derivative works of any part of the Service or as explicitly provided
          on the Site, or (iii) copy, rent, lease, distribute, or otherwise
          transfer any or the rights that you receive hereunder.
        </p>
        <p>
          You must abide by all applicable local, state, national and
          international laws and regulations.
        </p>
        <p>
          <strong>Registration</strong>
        </p>
        <p>
          In order to access some features of the Site, you will have to create
          an account. You must submit a valid email address and select a
          password and username (TrialSite username) during the registration
          process. You may never use another’s account without permission. When
          creating your account, you must provide accurate and complete
          information. Failure to do so will constitute a breach of the Terms of
          Use, which may result in immediate termination of your TrialSite
          account. You must not (i) select or use as a TrialSite username a name
          of another person with the intent to impersonate that person; (ii) use
          as a TrialSite username a name subject to any rights of a person other
          than you without appropriate authorization; or (iii) use as a
          TrialSite username a name that is otherwise offensive, vulgar or
          obscene. TrialSite reserves the right to refuse registration of or
          cancel an TrialSite username in its sole discretion. You are solely
          responsible for activity that occurs on your account and will be
          responsible for maintaining the confidentiality of your TrialSite
          password. You may never use another user’s account without such other
          user’s express permission. You will immediately notify TrialSite in
          writing of any unauthorized use of your account, or other
          account-related security breach of which you are aware.
        </p>
        <p>
          <strong>Subscriptions</strong>
        </p>
        <p>
          Trialsite derives the majority of its revenue from users subscribing
          for access to the site. Subscriptions are monthly unless stated
          otherwise, and may be cancelled (by you) at any time without notice.
          If you elect to cancel your monthly subscription, it will remain in
          effect until the next billing date and thereafter you will loose
          access to the content. We do not offer pro-rata refunds of unused
          portions of the monthly subscriptions.
        </p>
        <p>
          <strong>Third Party Sites</strong>
        </p>
        <p>
          The Service may permit you to link to other websites or resources on
          the Internet, and other websites or resources may contain links to the
          Site. These other websites are not under TrialSite’s control, and you
          acknowledge that TrialSite is not responsible or liable for the
          content, functions, accuracy, legality, appropriateness or any other
          aspect of such websites or resources. The inclusion of any such link
          does not imply endorsement by TrialSite or any association with its
          operators. You further acknowledge and agree that TrialSite will not
          be responsible or liable, directly or indirectly, for any damage or
          loss caused or alleged to be caused by or in connection with the use
          of or reliance on any such Content, goods or services available on or
          through any such website or resource.
        </p>
        <p>
          <strong>Right to Use TrialSite Content</strong>
        </p>
        <p>
          <strong>Content Generally</strong>
        </p>
        <p>
          You agree that the Service contains Content specifically provided by
          TrialSite, its users and/or its partners and that such Content is
          protected by copyrights, trademarks, service marks, patents, trade
          secrets or other proprietary rights and laws. Except as expressly
          authorized below or otherwise by TrialSite in writing, you must not
          sell, license, rent, modify, distribute, copy, reproduce, transmit,
          publicly display, publicly perform, publish, adapt, edit or create
          derivative works from such Content. However, TrialSite hereby grants
          you a limited, revocable, non-sublicensable license to display the
          Content (excluding any software code) using the means provided for
          such by TrialSite (e.g., through the use of “embed” codes); provided
          that you retain all copyright and other proprietary notices contained
          therein. Except as set forth below, reproducing, copying or
          distributing any Content, materials or design elements on the Site for
          any other purpose is strictly prohibited without the express prior
          written permission of TrialSite. Please read our Content Licensing
          Policy for important information.
        </p>
        <p>
          <strong>Guide Content and Photographs</strong>
        </p>
        <p>
          All Content is for informational purposes only, and is general advice,
          not intended to be relied upon to offer a solution to a specific
          problem or as a substitute for the advice of a qualified healthcare
          professional. TrialSite does not recommend use of the Content in lieu
          of professional advice or delay in seeking professional advice based
          on the Content. TrialSite does not recommend use of the Content for
          diagnosing or treating health or other problems.
        </p>
        <p>
          <strong>User Submissions</strong>
        </p>
        <p>
          The Service may provide registered members with the ability to upload,
          submit, disclose, distribute or otherwise post (hereafter, “posting”)
          content (including, without limitation, information, text [including
          edits and new text] for guides, data, photographs and images) to the
          Service (User Submissions). While you, as the creator of that content,
          will retain copyrights and the freedom to use your own works in any
          manner you choose, by posting User Submissions on or at the Site or
          otherwise through the Service, you:
        </p>
        <p>
          grant to TrialSite, its affiliates and their assignees a worldwide,
          perpetual, irrevocable, non-exclusive, sublicensable, transferable,
          royalty-free right to use, reproduce, display, perform, adapt, modify,
          distribute, translate, make derivative works of, incorporate into
          other works, add metadata associated with, and otherwise exploit such
          User Submissions, including without limitation, any concepts, ideas or
          know-how embodied therein, in any form and for any purpose, including
          without limitation promoting and redistributing part or all of the
          Site (and derivative works thereof) or the Service in any media format
          or technology now known or hereafter developed, in connection with the
          Site and TrialSite’s (and its successors’ and affiliates’) business.
          Without limiting the foregoing and for the avoidance of doubt, this
          license grants TrialSite to display commercial advertising and User
          Submissions anywhere on the Site, including without limitation
          alongside, on the same page as, and/or superimposed on any User
          Submissions; represent, warrant and covenant that (i) you own or
          otherwise control all rights to such User Submissions (including any
          pictures contained therein) and that disclosure and use of such User
          Submissions by TrialSite (including without limitation, publishing
          content on or at the Site) will not infringe or violate the rights of
          any third party; (ii) you own or have secured all necessary licenses,
          rights, consents and permissions for such User Submissions and
          authorize TrialSite to make use of these User Submissions in the
          manner contemplated by the Service and these Terms of Use; (iii) that
          the content of each User Submission is truthful and accurate; (iv) use
          of the User Submission you supply does not violate these Terms of Use
          and will not cause injury to any person or entity; (v) the holder of
          any rights, including moral rights in such User Submissions, has
          completely and effectively waived all such rights and validly and
          irrevocably granted to you the right to grant the license stated
          above;
        </p>
        <p>
          acknowledge that such User Submissions may not be treated
          confidentially; agree that you will reuse all User Submissions only
          for non-commercial purposes and abide by the Creative Commons
          Attribution Non-Commercial Share Alike license.
        </p>
        <p>
          You must not provide TrialSite with any confidential or proprietary
          information that you desire or are required to keep secret. All User
          Submissions will be considered non-confidential and TrialSite is under
          no obligation to treat User Submissions as proprietary information.
          You are solely responsible for the User Submissions you post on or
          through the Service. TrialSite reserves the right to use User
          Submissions as it deems appropriate, including, without limitation,
          deleting, editing, modifying, rejecting, or refusing to post them.
          TrialSite is under no obligation to offer you any payment for User
          Submissions or the opportunity to edit, delete or otherwise modify
          Content once it has been submitted to TrialSite. TrialSite will have
          no duty to attribute authorship of User Submissions to you, and will
          not be obligated to enforce any form of attribution by third parties.
        </p>
        <p>
          TrialSite has no obligation to monitor the Site, Service, Content, or
          User Submissions. TrialSite may remove any User Submission at any time
          for any reason (including, but not limited to, upon receipt of claims
          or allegations from third parties or authorities relating to such User
          Submission), or for no reason at all.
        </p>
        <p>
          <strong>Termination</strong>
        </p>
        <p>
          TrialSite may terminate the Service or your access to all or any part
          of the Service at any time, with or without cause, with or without
          notice, effective immediately. If you wish to terminate your account,
          contact us. All provisions of the Terms of Use which by their nature
          should survive termination will survive termination, including,
          without limitation, ownership provisions, warranty disclaimers,
          indemnity and limitations of liability.
        </p>
        <p>
          <strong>No Warranties</strong>
        </p>
        <p>
          THE SERVICE IS PROVIDED “AS IS” AND “AS AVAILABLE” AND IS WITHOUT
          WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED
          TO, THE IMPLIED WARRANTIES OF TITLE, NON-INFRINGEMENT, MERCHANTABILITY
          AND FITNESS FOR A PARTICULAR PURPOSE, AND ANY WARRANTIES IMPLIED BY
          ANY COURSE OF PERFORMANCE OR USAGE OF TRADE, ALL OF WHICH ARE
          EXPRESSLY DISCLAIMED. TRIALSITE MAKES NO WARRANTIES OR REPRESENTATIONS
          ABOUT THE ACCURACY OR COMPLETENESS OF THE SITE’S CONTENT OR THE
          CONTENT OF ANY SITES LINKED TO THIS SITE AND ASSUMES NO LIABILITY OR
          RESPONSIBILITY FOR ANY (I) ERRORS, MISTAKES, OR INACCURACIES OF
          CONTENT, (II) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE
          WHATSOEVER, RESULTING FROM YOUR ACCESS TO AND USE OF THE SERVICE,
          (III) CONSEQUENCES OF USING THE SITE OR YOUR EXPOSURE TO ANY CONTENT
          OR USER SUBMISSIONS ON THE SITE, (IV) UNAUTHORIZED DISCLOSURE OF
          IMAGE, INFORMATION OR DATA THAT RESULTS FROM THE UPLOAD, DOWNLOAD OR
          STORAGE OF USER SUBMISSIONS, OR (V) STATISTICS PROVIDED TO YOU OR
          OTHER USERS OF THE SERVICE INCLUDING BUT NOT LIMITED TO SITE ACTIVITY,
          SEARCH RESULTS, OR CONTENT VIEWS. TRIALSITE IS NOT RESPONSIBLE FOR ANY
          SEARCH RESULTS OR RANKINGS OR THE ADDITION OF OR CHANGE TO ASSOCIATED
          METADATA OF CONTENT ON THE SITE. TRIALSITE, AND ITS DIRECTORS,
          EMPLOYEES, AGENTS, SUPPLIERS, PARTNERS AND CONTENT PROVIDERS DO NOT
          WARRANT THAT: (A) THE SERVICE WILL BE SECURE OR AVAILABLE AT ANY
          PARTICULAR TIME OR LOCATION; (B) ANY DEFECTS OR ERRORS WILL BE
          CORRECTED; (C) ANY CONTENT OR SOFTWARE AVAILABLE AT OR THROUGH THE
          SERVICE IS FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS; (D) THE SITE
          OR THE SERVICE WILL OPERATE IN COMBINATION WITH ANY OTHER HARDWARE,
          SOFTWARE, SYSTEM OR DATA, OR (E) THE RESULTS OF USING THE SERVICE WILL
          MEET YOUR REQUIREMENTS. TRIALSITE DOES NOT WARRANT, ENDORSE,
          GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE
          ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THE SERVICE OR ANY
          HYPERLINKED SITE OR FEATURED IN THE CONTENT OF THE SITE OR ANY BANNER
          OR OTHER ADVERTISING, AND TRIALSITE WILL NOT BE A PARTY TO OR IN ANY
          WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN YOU AND
          THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES. AS WITH THE PURCHASE OF
          A PRODUCT OR USE OF A SERVICE THROUGH ANY MEDIUM OR IN ANY
          ENVIRONMENT, YOU SHOULD USE YOUR BEST JUDGMENT AND EXERCISE CAUTION
          WHERE APPROPRIATE. YOUR USE OF THE SERVICE AND ANY CONTENT IS SOLELY
          AT YOUR OWN DISCRETION AND RISK. WITHOUT LIMITATION OF THE GENERALITY
          OF THE FOREGOING, YOU ACKNOWLEDGE AND AGREE THAT YOU ARE SOLELY
          RESPONSIBLE FOR (1) THE DECISIONS THAT YOU MAY MAKE REGARDING THE
          SERVICE; (2) USE OF THE SERVICE OR CONTENT INCLUDING WITHOUT
          LIMITATION ANY CONTENT, DATA, INFORMATION, OR OTHER MATERIAL ACCESSED
          BY YOU IN CONNECTION WITH THE SERVICE OR THROUGH YOUR ACCOUNT,
          COMPUTER SYSTEM OR MOBILE DEVICE OR ANY LOSS OF DATA; AND (3) ANY
          LOSS, DAMAGE OR OTHER EFFECTS ON YOU THAT MAY RESULT FROM USE OF THE
          SERVICE OR ANY CONTENT OR THE FAILURE TO COMPLY WITH THESE TERMS. NO
          INFORMATION OR ADVICE, WHETHER WRITTEN OR ORAL, OBTAINED BY YOU FROM
          TRIALSITE OR THROUGH THE SERVICE WILL CREATE ANY WARRANTY OR IN ANY
          WAY AFFECT THE DISCLAIMERS OF WARRANTY OR LIMITATIONS OF LIABILITY
          EXPRESSLY PROVIDED IN THESE TERMS.
        </p>
        <p>
          <strong>Limitation of Liability</strong>
        </p>
        <p>
          IN NO EVENT WILL TRIALSITE, NOR ITS DIRECTORS, EMPLOYEES, AGENTS,
          PARTNERS, SUPPLIERS OR CONTENT PROVIDERS, BE LIABLE UNDER CONTRACT,
          TORT, STRICT LIABILITY, NEGLIGENCE OR ANY OTHER LEGAL THEORY WITH
          RESPECT TO THE SERVICE (I) FOR ANY LOST PROFITS OR SPECIAL, INDIRECT,
          INCIDENTAL, PUNITIVE, OR CONSEQUENTIAL DAMAGES OF ANY KIND WHATSOEVER,
          SUBSTITUTE GOODS OR SERVICES ARISING FROM (A) ERRORS, MISTAKES, OR
          INACCURACIES OF CONTENT, OR (B) PERSONAL INJURY OR PROPERTY DAMAGE, OF
          ANY NATURE WHATSOEVER, RESULTING FROM YOUR ACCESS TO THE SITE AND USE
          OF THE SERVICE, (II) FOR ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE
          (REGARDLESS OF THE SOURCE OF ORIGINATION), OR (III) FOR ANY DIRECT
          DAMAGES IN EXCESS OF (IN THE AGGREGATE) US$10. TO THE MAXIMUM EXTENT
          PERMITTED BY APPLICABLE LAW, TRIALSITE ASSUMES NO LIABILITY OR
          RESPONSIBILITY FOR ANY (I) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY
          NATURE WHATSOEVER, RESULTING FROM YOUR ACCESS TO OR USE OF OUR
          SERVICE; (II) ERRORS OR OMISSIONS IN ANY CONTENT OR LOSS OR DAMAGE
          INCURRED AS A RESULT OF THE USE OF ANY CONTENT POSTED OR OTHERWISE
          MADE AVAILABLE THROUGH THE SERVICE; OR (III) USER CONTENT OR THE
          DEFAMATORY, OFFENSIVE, OR ILLEGAL CONDUCT OF ANY THIRD PARTY. SOME
          STATES DO NOT ALLOW THE EXCLUSION OR LIMITATION OF INCIDENTAL OR
          CONSEQUENTIAL DAMAGES, SO CERTAIN OF THE ABOVE LIMITATIONS AND
          EXCLUSIONS MAY NOT APPLY TO YOU.
        </p>
        <p>
          <strong>Indemnification</strong>
        </p>

        <p>
          You will defend, indemnify, and hold harmless TrialSite, its
          affiliates and each of its, and its affiliates’ employees,
          contractors, directors, suppliers and representatives from all
          liabilities, claims, and expenses, including reasonable attorneys’
          fees and legal expenses, that arise from (i) your use or misuse of, or
          access to, the Service; (ii) your violation of the Terms of Use; or,
          (iii) the infringement by you, or any third party using your account,
          of any intellectual property, privacy, publicity or other right of any
          person or entity. TrialSite reserves the right to assume the exclusive
          defense and control of any matter otherwise subject to indemnification
          by you, in which event you will assist and cooperate with TrialSite in
          asserting any available defenses. This obligation survives
          indefinitely the termination and/or expiration of these Terms of Use
          and/or your status as a TrialSite User.
        </p>
        <p>
          <strong>International Use</strong>
        </p>
        <p>
          TrialSite makes no representation that the Content is appropriate or
          available for use in locations outside of the United States, and
          accessing the Service is prohibited from territories where such
          Content is illegal. If you access the Service from other locations,
          you do so at your own initiative and are responsible for compliance
          with local laws.
        </p>
        <p>
          <strong>Dispute Resolution</strong>
        </p>
        <p>
          A printed version of the Terms of Use and of any notice given in
          electronic form will be admissible in judicial or administrative
          proceedings based upon or relating to the Terms of Use to the same
          extent and subject to the same conditions as other business documents
          and records originally generated and maintained in printed form. You
          and TrialSite agree that any cause of action arising out of or related
          to the Service must commence within one (1) year after the cause of
          action arose; otherwise, such cause of action is permanently barred.
        </p>
        <p>
          The Terms of Use will be governed by and construed in accordance with
          the laws of the State of Utah, excluding its conflicts of law rules,
          and all applicable federal laws.
        </p>
        <p>
          ALL DISPUTES RELATING TO USE OF THIS SITE OR SERVICES WILL BE RESOLVED
          THROUGH CONFIDENTIAL AND BINDING MEDIATION. A mediator appointed by
          the parties will assist in attempting to resolve the dispute. Each
          party acts in an individual capacity and not as part of a class. The
          mediator may not consolidate claims of more than one party, or preside
          over any class proceeding. If the parties are unable to agree on a
          settlement, the mediator will act as an arbitrator to resolve the
          issue(s) on which the parties fail to agree and will impose a final
          and binding resolution on the parties with the effect of an
          arbitration decision. The mediator’s final and binding resolution will
          constitute an arbitration award and will be enforceable under the
          Federal Arbitration Act.
        </p>
        <p>
          You expressly agree that the exclusive jurisdiction and venue for
          enforcing this binding mediation agreement, or any litigation arising
          in the event this binding mediation agreement is held to be
          unenforceable, will be only the state or federal courts located in
          Utah, and you further agree and submit to the exercise of personal
          jurisdiction and venue of such courts. Use of the Service is not
          authorized in any jurisdiction that does not give effect to all
          provisions of the Terms of Use, including without limitation, this
          section.
        </p>
        <p>
          BY USING THIS SITE OR SERVICES, YOU AGREE TO THE TERMS OF THE BINDING
          MEDIATION AGREEMENT, AND YOU GIVE UP YOUR RIGHT TO ASSERT OR DEFEND A
          CLAIM IN COURT AND YOUR RIGHT TO PARTICIPATE IN ANY CLASS ACTION
          PROCEEDING.
        </p>
        <p>
          <strong>Miscellaneous</strong>
        </p>
        <p>
          The Terms of Use are the entire agreement between you and TrialSite
          with respect to the Service and use of this Site, and supersede all
          prior or contemporaneous communications and proposals (whether oral,
          written or electronic) between you and TrialSite with respect to this
          Site or any other of the subject matter hereof. If any provision of
          the Terms of Use is found to be unenforceable or invalid, that
          provision will be limited or eliminated to the minimum extent
          necessary so that the Terms of Use will otherwise remain in full force
          and effect and enforceable. No failure of TrialSite or the Site to
          enforce any of its rights under these Terms of Use will act as a
          waiver of such rights. The Terms of Use are personal to you, and are
          not assignable, transferable or sublicensable by you except with
          TrialSite’s prior written consent. TrialSite may assign, transfer or
          delegate any of its rights and obligations hereunder without consent.
          No agency, partnership, joint venture, or employment relationship is
          created as a result of the Terms of Use and neither party has any
          authority of any kind to bind the other in any respect. In any action
          or proceeding to enforce rights under the Terms of Use, the prevailing
          party will be entitled to recover costs and attorneys’ fees. All
          notices under the Terms of Use will be in writing and will be deemed
          to have been duly given when received, if personally delivered or sent
          by certified or registered mail, return receipt requested; when
          receipt is electronically confirmed, if transmitted by facsimile or
          e-mail; or the day after it is sent, if sent for next day delivery by
          recognized overnight delivery service. Unless otherwise indicated, the
          Terms of Use and all Content provided by TrialSite are copyright
          TrialSite, all rights reserved. TrialSite, and the TrialSite logo, as
          well as any other logos or brand features owned by TrialSite, are
          trademarks or service marks of TrialSite or otherwise proprietary to
          TrialSite. The names of actual companies and products mentioned on the
          Site may be the trademarks or service marks of their respective
          owners.
        </p>
        <p>
          <strong>Contact</strong>
        </p>
        <p>You can contact us at the following address:</p>
        <p>
          TrialSite, Inc
          <br />
          159 W Broadway, Suite 200
          <br />
          Salt Lake City, UT 84101
        </p>
        <p>
          <S.MailTo href="mailto:info@trialsitenews.com">
            <strong>info@trialsitenews.com</strong>
          </S.MailTo>
        </p>
      </S.Content>
    </S.Article>
  )
}

TOS.defaultProps = defaultProps
TOS.propTypes = propTypes

export default TOS
